import React from "react";
import Page from "../templates/empower/career-development/career-development-page";

export default function home() {
  return (
    <div>
      <Page />
    </div>
  );
}
